module.exports = __webpack_public_path__ + "static/img/piz_bcg2.c00719fa.png";